angular.module('unergie.main')
.run(($rootScope) =>
    $rootScope.$on('$stateChangeSuccess', () => window.scrollTo(0, 0))
)
